module.exports = __webpack_public_path__ + "assets/img/play.7e90ceb5.svg";